import { call, put } from "redux-saga/effects";
import { AuthResponse } from "reduxStore/dataTypes";
import { adminLogin } from "services/apiService";
import {
  authAdminFailure,
  authAdminRequest,
  authAdminSuccess,
} from "../reducers/adminAuthReducer";
import { AxiosError } from "axios";

function* adminAuthSaga(action: any): Generator<any, void, AuthResponse | any> {
  try {
    const { payload } = action;
    yield put(authAdminRequest());
    let response = yield call(adminLogin, payload);
    yield put(authAdminSuccess(response.data));
  } catch (error: any) {
    if (error instanceof AxiosError) {
      yield put(authAdminFailure(error.response?.data?.message));
    } else {
      if (error && error.response) {
        yield put(authAdminFailure(error.response));
      } else {
        yield put(authAdminFailure(error.message));
      }
    }
  }
}

export default adminAuthSaga;
